import map from 'lodash/fp/map';

export const parseSystemStateNotification = systemStateNotification => ({
    ...systemStateNotification,
    id: `${systemStateNotification.serialNumber}_${systemStateNotification.timestamp}`,
});

export const parseSystemStateNotifications = packages => map(parseSystemStateNotification, packages);
